<template>
  <b-modal
    id="modalExporter"
    ref="modalExporter"
    centered
    size="lg"
    :title="$t('common.export')"
  >
    <b-overlay
      :show="isLoading"
      variant="primary"
      opacity="0.3"
    >

      <b-form>
        <b-row>
          <b-col
            cols="12"
            lg="12"
          >
            <b-form-group
              :label="$t('attachments.exporters')"
            >
              <div class="d-flex align-items-center justify-content-end">
                <v-select
                  v-model="exporterSelected"
                  class="w-100"
                  :options="exporterOptions"
                  :placeholder="$t('attachments.filter-exporters')"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('attachments.export-name')"
            >
              <b-input-group>
                <b-form-input
                  id="rename-export"
                  v-model="exporterName"
                  :placeholder="$t('attachments.filter-export-name')"
                />
                <b-input-group-append v-if="exporterSelected !== null">
                  <b-button
                    id="btn-delete-exporter"
                    class="btn-icon"
                    variant="outline-primary"
                    @click="deletee()"
                  >
                    <feather-icon icon="Trash2Icon" />
                    <b-tooltip
                      triggers="hover"
                      target="btn-delete-exporter"
                      :title=" $t('common.delete')"
                      :delay="{ show: 100, hide: 50 }"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row></b-form>

      <b-row
        v-for="(group, index) in groups"
        :key="index"
      >
        <h5 class="ml-2">
          {{ group }}
        </h5>
        <b-form-checkbox-group
          v-model="optionsChecked"
          class="p-1 checkbox-modal"

          :options="filterOptions(group)"
          inline
          switch
        />
      </b-row>
    </b-overlay>

    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-primary"
          class="btn-icon rounded-circle float-left"
          @click="unselect"
        >
          <feather-icon icon="CheckSquareIcon" />
        </b-button>

        <b-button-group
          class="float-right"
        >
          <b-button
            variant="outline-primary"
            :disabled="!isValidate"
            @click="ok"
          >
            {{ $t('common.export') }}
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="!isValidate"
            @click="submit(false)"
          >
            {{ $t('common.save') }}
          </b-button>
          <b-button
            variant="outline-primary"
            @click="cancel"
          >
            {{ $t('common.cancel') }}
          </b-button>
        </b-button-group>
      </div>
    </template>

  </b-modal>
</template>

<script>
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
import {
  BRow, BCol, BForm, BModal, BButton, BButtonGroup, VBModal, BFormCheckboxGroup, BOverlay,
  BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BTooltip,
} from 'bootstrap-vue'
import {
  toastSuccessOptions, toastErrorOptions, swalDeleteOptions, removeFromArray, decode, formatDate,
} from '@/views/layouts/layouts.utils'
import vSelect from 'vue-select'
import authService from '@/vue.auth.service'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BButton,
    BButtonGroup,
    BInputGroup,
    BInputGroupAppend,
    BTooltip,
    BOverlay,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      table: null,
      callback: null,
      options: [],
      optionsChecked: [],
      exporterOptions: [],
      exporterName: null,
      exporterSelected: null,
      isLoading: false,
    }
  },
  computed: {
    isValidate() {
      return this.optionsChecked && this.optionsChecked.length > 0 && this.exporterName
    },
    groups() {
      return [...new Set(this.options.map(o => o.group))]
    },

  },
  async mounted() {
    this.$watch('exporterSelected', async () => {
      if (this.exporterSelected) {
        const area = await authService.currentArea()
        const response = await axios.get('/api/storage', {
          params: { aid: area.aid, fid: this.exporterSelected.uuid },
          responseType: 'blob',
        })
        const blob = new Blob([response.data], { type: response.data.type })
        this.optionsChecked = JSON.parse(await blob.text())
        this.exporterName = `${this.exporterSelected.label}`
      } else this.clean()
    })
  },
  methods: {
    ok() {
      if (this.callback) {
        this.isLoading = true
        this.callback(
          this.options.filter(o => this.optionsChecked.includes(o.value))
            .map(o => ({ key: o.value, header: o.text })),
          `${this.exporterName}_${formatDate(new Date(), 'yyyyMMDD')}.xlsx`,
        )
      }
    },
    deletee() {
      const swalOptions = swalDeleteOptions
      swalOptions.target = document.getElementById('modalExporter')
      this.$swal(swalOptions).then(async result => {
        if (result.value === true) {
          await this.submit(true)
        }
      })
    },
    async submit(pleaseDelete) {
      const area = await authService.currentArea()
      const { settings } = area
      if (!settings.exporters) settings.exporters = []
      try {
        if (pleaseDelete) {
          removeFromArray(settings.exporters, this.exporterSelected)
        } else {
          const formData = new FormData()
          formData.append('upload', new Blob([JSON.stringify(this.optionsChecked)], { type: 'application/json' }), `${this.table}_${this.exporterName}.json`)
          const response = await axios.put('/api/storage', formData, {
            params: { aid: area.aid },
            headers: { 'Content-Type': 'application/json' },
          })

          if (!this.exporterSelected) {
            const e = {
              label: this.exporterName,
              category: this.table,
              uuid: response.data[0],
              lastUpdate: new Date(),
            }
            settings.exporters.push(e)
            this.exporterSelected = e
          } else {
            const e = settings.exporters.find(t => t.uuid === this.exporterSelected.uuid)
            e.lastUpdate = new Date()
            e.label = this.exporterName
            e.uuid = response.data[0]
          }
        }

        await authService.saveSettings(area.aid, settings)
        this.exporterOptions = settings.exporters.filter(t => t.category === this.table)
        if (pleaseDelete) this.clean()
        this.$toast(toastSuccessOptions, { position: 'top-center' })
      } catch (error) {
        const message = toastErrorOptions
        if (error.response) message.props.text = decode(error.response.data.error)
        this.$toast(message, { position: 'top-center' })
      }
    },
    clean() {
      this.exporterSelected = null
      this.exporterName = ''
      this.optionsChecked = []
      this.switch(false)
    },
    cancel() {
      this.$refs.modalExporter.hide()
    },
    unselect() {
      const switcher = (this.optionsChecked.length > (this.options.length / 2))
      this.switch(switcher)
    },
    switch(switcher) {
      this.optionsChecked = this.options.filter(o => o.value && ((switcher === true && o.disabled === true) || switcher === false)).map(o => o.value)
    },
    filterOptions(group) {
      return this.options.filter(o => o.group === group)
    },

    async show(table, callback) {
      if (table && callback) {
        this.callback = callback
        this.table = (table.includes('#') ? table.split('#')[0] : table)
        const sub = (table.includes('#') ? table.split('#')[1] : null)
        this.options = this.loadOptions(this.table, sub)

        const currentArea = await authService.currentArea()
        const { exporters } = currentArea.settings
        if (!this.exporterSelected) {
          this.exporterOptions = exporters ? exporters.filter(t => t.category === this.table) : []
          this.clean()
        }
        this.isLoading = false
        this.$refs.modalExporter.show()
      }
    },
    loadOptions(table, sub) {
      const options = []
      const isGiverMode = (table === 'givers')

      if (table === 'donations' || table === 'givers') {
        options.push(
          { text: this.$t('donations.issue-date'), value: 'issueDate' },
          { text: this.$t('donations.amount'), value: 'amount' },
          { text: this.$t('donations.currency'), value: 'currency' },
          { text: this.$t('donations.filter-payments-label'), value: 'dinfos.payments' },
          { text: this.$t('donations.filter-donations-label'), value: 'dinfos.type' },
          { text: this.$t('donations.filter-category-label'), value: 'dinfos.category' },
          { text: this.$t('projects.nation'), value: 'dinfos.nation' },
          { text: this.$t('common.notes'), value: 'dinfos.notes' },
          { text: this.$t('donations.tags'), value: 'dinfos.tags' },

          // { text: this.$t('donations.cuas'), value: 'dinfos.cuas' },
        )
      }
      const innerTable = (table === 'donations' || table === 'givers')
      if (!isGiverMode && (table === 'contributors' || innerTable)) {
        const contributors = [
          { text: this.$t('contributors.full-name'), value: 'fullName', disabled: !innerTable },
          { text: this.$t('contributors.code'), value: 'infos.contributorCode' },
          { text: this.$t('contributors.contributor-type'), value: 'infos.contributorType' },
          { text: this.$t('contributors.filter-status-label'), value: 'infos.status' },
          { text: this.$t('contributors.gender'), value: 'infos.gender' },
          { text: this.$t('contributors.birth-date'), value: 'infos.birthDate' },
          { text: this.$t('contributors.fiscal-code'), value: 'infos.fiscalCode' },
          { text: this.$t('contributors.email'), value: 'infos.email' },
          { text: this.$t('contributors.contact'), value: 'infos.contact' },
          { text: this.$t('contributors.address-line'), value: 'infos.address.addressLine' },
          { text: this.$t('contributors.address-postcode'), value: 'infos.address.postcode' },
          { text: this.$t('contributors.address-city'), value: 'infos.address.city' },
          { text: this.$t('contributors.address-kanton'), value: 'infos.address.kanton' },
          { text: this.$t('contributors.address-state'), value: 'infos.address.state' },
          { text: this.$t('contributors.annoAdesione'), value: 'infos.annoAdesione' },
          { text: this.$t('contributors.annoCancellazione'), value: 'infos.annoCancellazione' },
          { text: this.$t('contributors.sorgente'), value: 'infos.sorgente' },
          { text: this.$t('common.notes'), value: 'infos.notes' },
          { text: this.$t('contributors.filter-tags-label'), value: `${innerTable ? 'c' : ''}tags` },
        ]
        if (!innerTable) {
          contributors.push({ text: this.$t('contributors.donations'), value: 'donations_amount' })
          contributors.push({ text: this.$t('contributors.donations_distinct'), value: 'donations_distinct' })
          contributors.push({ text: this.$t('donations.currency'), value: 'donations_currency' })
        }

        if (innerTable) {
          const suffix = this.$t('donations.contributor-name')
          contributors.forEach(o => { o.text += ` (${suffix})`; o.group = suffix })
        }
        contributors.forEach(o => { options.push(o) })
      }
      if (table === 'projects' || innerTable) {
        const prefix = (innerTable ? 'p' : '')
        const projects = [

          {
          // eslint-disable-next-line no-nested-ternary
            text: this.$t(innerTable ? 'donations.project-name' : (sub === 'sad' ? 'projects.sad-name' : 'projects.project-name')),
            value: 'projectName',
            disabled: !innerTable,
          },
          { text: this.$t('projects.filter-status-label'), value: `${prefix}infos.status` },
          { text: this.$t('projects.mission'), value: `${prefix}infos.missionName` },
          { text: this.$t('projects.nation'), value: `${prefix}infos.nation` }]

        if (!isGiverMode && (sub === 'sad' || innerTable)) {
          projects.push.apply(projects, [
            { text: this.$t('projects.gender'), value: `${prefix}infos.gender`, group: 'sad' },
            { text: this.$t('projects.sad-code'), value: `${prefix}infos.projectCode`, group: 'sad' },
            { text: this.$t('projects.birth-date'), value: `${prefix}infos.birthDate`, group: 'sad' },
            { text: this.$t('projects.address-line'), value: `${prefix}infos.addressLine`, group: 'sad' },
            { text: this.$t('projects.school-class'), value: `${prefix}infos.schoolClass`, group: 'sad' },
            { text: this.$t('projects.triboo'), value: `${prefix}infos.triboo`, group: 'sad' },

          ])
        }
        if (sub === 'project' || innerTable) {
          projects.push.apply(projects, [
            { text: this.$t('projects.external-name'), value: `${prefix}infos.externalName`, group: 'project' },
            { text: this.$t('projects.filter-project-type'), value: `${prefix}infos.projectType`, group: 'project' },
            { text: this.$t('projects.project-date'), value: `${prefix}infos.projectDate`, group: 'project' },
            { text: this.$t('projects.total-amount'), value: `${prefix}infos.totalAmount`, group: 'project' },
            { text: this.$t('projects.total-currency'), value: `${prefix}infos.totalCurrency`, group: 'project' },
            { text: this.$t('projects.project-code'), value: `${prefix}infos.projectCode`, group: 'project' },
            { text: this.$t('projects.project-zone'), value: `${prefix}infos.zone`, group: 'project' },
            { text: this.$t('projects.web'), value: `${prefix}infos.web`, group: 'project' },
            { text: this.$t('projects.project-inspectory'), value: `${prefix}infos.inspectory`, group: 'project' },
            { text: this.$t('projects.found-from'), value: `${prefix}infos.foundFrom`, group: 'project' },
            { text: this.$t('projects.referrals'), value: `${prefix}infos.referrals`, group: 'project' },
          ])
        }
        projects.push.apply(projects, [
          { text: this.$t('common.notes'), value: `${prefix}infos.notes` },
          { text: this.$t('projects.filter-tags-label'), value: `${prefix}tags`, group: (!innerTable ? sub : 'sad') },
        ])
        if (!innerTable) {
          projects.push({ text: this.$t('projects.donations'), value: 'donations_amount' })
          projects.push({ text: this.$t('donations.currency'), value: 'donations_currency' })
          projects.push({ text: this.$t('projects.donations_distinct'), value: 'donations_distinct' })
          if (this.sub === 'project') {
            projects.push({ text: this.$t('donations.total-giver'), value: 'givers_amount' })
            projects.push({ text: this.$t('projects.givers_distinct'), value: 'givers_count' })
            projects.push({ text: this.$t('donations.balance-amount'), value: 'balance_amount' })
            projects.push({ text: this.$t('donations.balance-currency'), value: 'balance_currency' })
          }
        }
        projects.filter(o => o.group).forEach(o => { o.group = (this.$t(`projects.${o.group}`)); o.text += ` (${o.group})` })
        projects.forEach(o => { options.push(o) })
      }

      return options
    },
  },
}

</script>
<style>
.checkbox-modal .custom-checkbox  {
    min-width: 46%;
    padding-bottom: 0.75em!important;
}
</style>
